const SECTION_DATA = [
  {
    id: 1,
    image: "/wifi.svg",
    title: "High speed internet",
    description: " keep up with deadlines, emails and virtual meetings with anuninterrupted network connection all day long",
  },
  {
    id: 2,
    image: "/serenity.svg",
    title: "Serenity",
    description: " Our coworking space is situated in a peaceful, quiet and private environment that is very easy to locate.",
  },
  {
    id: 3,
    image: "/accessibility.svg",
    title: "Accessibility",
    description:
      "This is an inclusive space; We welcome all individuals from diverse backgrounds and industries. Always open at 9am - 5pm (Monday to Friday).",
  },
  {
    id: 4,
    image: "/comfortable.svg",
    title: "Comfortable Lounge",
    description:
      "Discover the perfect balance in our lounge space where you can relax, recharge and find inspiration for your projects.",
  },
  // {
  //   id: 5,
  //   image: "/stimulating.svg",
  //   title: "Stimulating",
  //   description: "BoldSpace is a friendly and vibrant community where like minded entrepreneurs connect",
  // },
  {
    id: 6,
    image: "/collaborative.svg",
    title: "Collaborative",
    description: "Share ideas, knowledge, business opportunities and network with other members",
  },
  {
    id: 7,
    image: "/affordable.svg",
    title: "Affordable Pricing",
    description: "Experience affordable prices that empower your productivity and success.",
  },
  {
    id: 8,
    image: "/constant.svg",
    title: "Constant Electricity Supply",
    description:
      "Stay connected with our constant power supply that never gets interrupted to ensure your daily tasks are duly achieved.",
  },
  {
    id: 9,
    image: "/complimentary.svg",
    title: " Complimentary coffee",
    description: "Fuel your productivity with a free cup of coffee - a perfect blend to kickstart your workday!",
  },
  {
    id: 10,
    image: "/security.svg",
    title: "Security",
    description:
      "At BoldSpace, your safety is our priority. We operate on high standard security measures to ensure a safe working environment, free from hazardous activities.",
  },
];

export default SECTION_DATA;
